import { IconArrowRight, IconClose } from '@/components/svg-symbols/icons';
import { useDrawer } from './context/use-drawer';
interface Props {
  title: string;
  htmlFor: string;
  hasBackButton: boolean;
  drawerId?: string;
}
const DrawerHeader = ({
  title,
  htmlFor,
  hasBackButton,
  drawerId
}: Props) => {
  const {
    closeDrawer
  } = useDrawer();
  return <div className='flex h-14 w-full justify-between p-4 text-text-black shadow-sm' data-sentry-component="DrawerHeader" data-sentry-source-file="drawer-header.tsx">
            <div>
                {hasBackButton && drawerId && <label htmlFor={drawerId} className='cursor-pointer'>
                        <IconArrowRight className='h-6 w-6 text-text-black' />
                    </label>}
            </div>
            <span className='bg-white text-base font-medium'>{title}</span>

            <label onClick={() => closeDrawer(htmlFor)} className='cursor-pointer'>
                <IconClose className='h-6 w-6 text-text-black' data-sentry-element="IconClose" data-sentry-source-file="drawer-header.tsx" />
            </label>
        </div>;
};
export default DrawerHeader;